/** MIME types browsers commonly assign to .csv files (incl. Windows Excel association). */
const CSV_MIME_TYPES = new Set([
  'text/csv',
  'application/csv',
  'text/plain',
  'application/vnd.ms-excel',
]);

/** MIME types that are never valid for a .csv upload. */
const NON_CSV_MIME_PREFIXES = ['image/', 'video/', 'audio/'] as const;

const NON_CSV_MIME_EXACT = new Set([
  'application/pdf',
  'application/zip',
  'application/x-zip-compressed',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.ms-excel.sheet.macroEnabled.12',
  'application/vnd.ms-excel.sheet.binary.macroEnabled.12',
  'text/html',
  'application/json',
]);

/** File picker filter — extension is the reliable cross-browser constraint. */
export const CSV_FILE_ACCEPT = '.csv,text/csv,application/csv,application/vnd.ms-excel';

export function isCsvFile(file: File): boolean {
  const name = file.name.trim().toLowerCase();
  if (!name.endsWith('.csv')) return false;

  const type = file.type.trim().toLowerCase();
  if (!type) return true;
  if (CSV_MIME_TYPES.has(type)) return true;
  if (NON_CSV_MIME_EXACT.has(type)) return false;
  if (NON_CSV_MIME_PREFIXES.some((prefix) => type.startsWith(prefix))) return false;

  // Unknown MIME but .csv extension — allow (OS-specific CSV types vary).
  return true;
}

export function formatFileSize(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(bytes < 10_240 ? 1 : 0)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}
